import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

let sequence = 0;
const listeners = new Set();
let pending = [];
const textOf = (value) => React.Children.toArray(value).map((child) => React.isValidElement(child) ? textOf(child.props.children) : String(child)).join('');
export const showToast = (content, type = 'info') => {
  if (!content) return;
  const notice = { id: ++sequence, content, type, duration: type === 'error' || textOf(content).length > 140 ? 6000 : 3000 };
  if (listeners.size) listeners.forEach((listener) => listener(notice));
  else pending = [...pending, notice].slice(-4);
};

function ToastItem({ notice, dismiss }) {
  useEffect(() => {
    const timer = setTimeout(() => dismiss(notice.id), notice.duration);
    return () => clearTimeout(timer);
  }, [notice.id, notice.duration, dismiss]);
  return <div className={`app-toast app-toast-${notice.type}`} role={notice.type === 'error' ? 'alert' : 'status'}>
    <span className="app-toast-symbol" aria-hidden="true">{notice.type === 'error' ? '!' : notice.type === 'success' ? '✓' : 'i'}</span>
    <div className="app-toast-content">{notice.content}</div>
    <button type="button" aria-label="Đóng thông báo" onClick={() => dismiss(notice.id)}>×</button>
  </div>;
}

export function ToastViewport() {
  const [notices, setNotices] = useState([]);
  const dismiss = React.useCallback((id) => setNotices((previous) => previous.filter((item) => item.id !== id)), []);
  useEffect(() => {
    const receive = (notice) => setNotices((previous) => [...previous, notice].slice(-4));
    listeners.add(receive);
    pending.forEach(receive); pending = [];
    return () => listeners.delete(receive);
  }, []);
  return createPortal(<div className="app-toast-stack" aria-label="Thông báo">{notices.map((notice) => <ToastItem key={notice.id} notice={notice} dismiss={dismiss} />)}</div>, document.body);
}

export default function ToastNotice({ children, className = '', role }) {
  const content = React.useRef(children); content.current = children;
  const signature = textOf(children);
  const delivered = React.useRef('');
  const type = className.includes('error') || role === 'alert' ? 'error' : className.includes('success') ? 'success' : 'info';
  useEffect(() => {
    const key = `${type}:${signature}`;
    if (delivered.current !== key) { delivered.current = key; showToast(content.current,type); }
  }, [signature,type]);
  // Keep actionable validation visible beside the form after the toast closes.
  return type === 'error' ? <p className="form-inline-error" role="alert">{children}</p> : null;
}
